import { ChangeDetectorRef, Component, EventEmitter, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as braintree from 'braintree-web';
import { loadScript } from "@paypal/paypal-js";
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { PAYPAL_CLIENT_ID } from '@equine-ui-nx/injection-tokens';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  standalone: true,
  selector: 'equine-ui-nx-payment-method-add-paypal',
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './payment-method-add-paypal.component.html',
  styleUrl: './payment-method-add-paypal.component.scss',
})
export class PaymentMethodAddPaypalComponent implements OnInit {

  paypalButtons: any;

  private readonly paypalClientId = inject(PAYPAL_CLIENT_ID);
  public readonly data = inject<{clientInstance: any, amount: number, type: 'ONE_TIME' | 'ONGOING'}>(MAT_DIALOG_DATA);

  paypalTokenized = new EventEmitter<{nonce: string}>();

  paying = signal(false);
  loading = signal(true);

  constructor(
    private cdRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.addPaypalVault();
  }

  addPaypalVault() {
    braintree.paypalCheckout.create({
      client: this.data.clientInstance,
    })
    .then((paypalCheckoutInstance) => {
      // Load the PayPal JS SDK (see Load the PayPal JS SDK section)
      const loadPayPalSDKOptions: any = {
        currency: 'USD', // Must match the currency passed in with createPayment
        intent: 'capture', // Must match the intent passed in with createPayment
        vault: true
      }
      paypalCheckoutInstance.loadPayPalSDK(loadPayPalSDKOptions)
        .then((paypal) => {

          if (this.data.type === 'ONE_TIME') {
            this.createPaypalButtonSinglePayment(paypal);
          } else {
            this.createPaypalButton(paypal);
          }
        }) 
      });
  }

  createPaypalButton(paypalCheckoutInstance: any) {
    loadScript({
      clientId: this.paypalClientId,
      components: ['buttons'],
      intent: 'capture',
      vault: true
    }).then((paypal) => {
      this.paypalButtons = (paypal as any).Buttons({
        style: {
          layout:  'horizontal',
          color:   'gold',
          shape:   'rect',
          label:   'pay',
          tagline: true
        },

        createBillingAgreement: () => {
          return paypalCheckoutInstance.createPayment({
            flow: 'vault', // Required
          });
        },

        onApprove: (orderData: any) => {
          this.loading.set(true);
          this.paying.set(true);
          this.cdRef.detectChanges();

          return paypalCheckoutInstance.tokenizePayment(orderData, (err: any, payload: any) => {
            this.paypalTokenized.emit(payload);
          });
        },
        onError: (error: any) => {
          this.paying.set(false);
          this.loading.set(false);
          this.cdRef.detectChanges();
        },
      });

      this.loading.set(false);
      this.paypalButtons?.render('#paypalButtonsVault');

    });
  }

  createPaypalButtonSinglePayment(paypalInstance: braintree.PayPalCheckout) {
    loadScript({
      clientId: this.paypalClientId,
      components: ['buttons'],
      intent: 'capture',
      vault: true
    }).then((paypal) => {
      if (!paypal) {
        return;
      } else {
        this.paypalButtons = (paypal as any).Buttons({
          style: {
            layout:  'horizontal',
            color:   'gold',
            shape:   'rect',
            label:   'pay',
            tagline: true
          },
          createOrder: () => {
            return paypalInstance.createPayment({
              flow: 'checkout' as any,
              amount: (Math.round(this.data.amount * 100) / 100).toString(),
              currency: 'USD',
              intent: 'capture' as any,
            });
          },
          onApprove: (orderData: any) => {
            this.loading.set(true);
            this.paying.set(true);
            this.cdRef.detectChanges();
            return new Promise((resolve, reject) => {
              paypalInstance.tokenizePayment(orderData).then((token: paypal.TokenizePayload) => {
                this.paypalTokenized.emit(token);
                resolve(token);
              })
              .catch((error) => {
                reject(error);
              });
            });
          },
          onError: (error: any) => {
            this.loading.set(false);
            this.paying.set(false);
            this.cdRef.detectChanges();
          },
        });

        this.loading.set(false);
        this.paypalButtons?.render('#paypalButtonsVault');
      }
    });
  }


}
